import $ from 'jquery';

var objectfit = function() {
    if (!Modernizr.objectfit) {
        $('.object-fit').each(function() {
            var $container = $(this),
                imgUrl = $container.find('img').prop('src'),
                objectfitFallbackUrl = $container.find('img').data('objectfit');

            if (objectfitFallbackUrl) {
                imgUrl = objectfitFallbackUrl;
            }

            if (imgUrl) {
                $container
                    .css('backgroundImage', 'url(' + imgUrl + ')')
                    .addClass('compat-object-fit');
            }
        });
    }
};

objectfit();

export default objectfit;



// WEBPACK FOOTER //
// ./resources/assets/js/polyfill/object-fit.js